import React from 'react';
import {
  GECKO_CONSTS,
  GeckoForm,
  GeckoFormField,
  GeckoModal,
  GeckoModalService,
  GeckoToastService,
} from 'ui';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { fetchConversationPerHourStats, saveWorkHours } from '../../actions';
import './index.scss';

const hoursOptions = new Array(24).fill(null).map((_, i) => ({
  value: i,
  label: `${i < 10 ? `0` : ''}${i}:00`,
}));

const WorkHoursModal = ({ filters = {} }) => {
  const workHours = useSelector((state) => state.statsRoute.workHours);

  const initialValues = workHours
    ? workHours
    : {
        startTime: null,
        endTime: null,
        timezone: null,
        workDays: [],
      };

  const validate = ({ startTime, endTime, timezone }) => {
    const errors = {};

    const startTimeNumber = Number(startTime);
    const endTimeNumber = Number(endTime);

    if (endTimeNumber <= startTimeNumber && endTimeNumber !== 0) {
      errors.time = 'End time must be after the Start time';
    }

    return errors;
  };

  const submit = (workHours) => {
    const formattedWorkHours = {
      ...workHours,
      startTime: Number(workHours.startTime),
      endTime: Number(workHours.endTime),
    };
    saveWorkHours(formattedWorkHours)
      .then(() => {
        fetchConversationPerHourStats(filters);
        new GeckoToastService().success('Your changes have been saved.');
        new GeckoModalService().close();
      })
      .catch((error) => {
        new GeckoToastService().error('Unable to save changes');
        console.log(error);
      });
  };

  return (
    <div className="WorkHoursModal">
      <GeckoForm
        initialValues={initialValues}
        validate={validate}
        onSubmit={submit}
        requiredFields={['startTime', 'endTime', 'timezone']}
      >
        {({ handleSubmit, errors, hasTriedToSubmit }) => (
          <GeckoModal
            name={'Set Working Hours'}
            btns={[
              {
                name: 'Cancel',
                handler: () => new GeckoModalService().close(),
                preset: GECKO_CONSTS.BTN_PRESET_CLOSE,
              },
              {
                name: 'Save Working Hours',
                preset: GECKO_CONSTS.BTN_PRESET_SAVE,
                primary: true,
                handler: handleSubmit,
              },
            ]}
          >
            <div className="row">
              <div className="WorkHoursForm">
                <GeckoFormField
                  fieldType="select"
                  name="startTime"
                  label="Start Time"
                  options={hoursOptions}
                  placeholder="Start Time"
                  width="50%"
                />
                <GeckoFormField
                  fieldType="select"
                  name="endTime"
                  label="End Time"
                  options={hoursOptions}
                  placeholder="End Time"
                  width="50%"
                  error={hasTriedToSubmit && errors.time}
                />
                <GeckoFormField
                  fieldType="select"
                  name="timezone"
                  options={moment.tz
                    .names()
                    .map((tz) => ({ value: tz, label: tz }))}
                  label="Timezone"
                  placeholder="Set Timezone"
                  error={hasTriedToSubmit && errors.timezone}
                />
                <GeckoFormField
                  fieldType="select_multi_buttons"
                  name="workDays"
                  options={[
                    { value: 'Sunday', label: 'Sun' },
                    { value: 'Monday', label: 'Mon' },
                    { value: 'Tuesday', label: 'Tues' },
                    { value: 'Wednesday', label: 'Wed' },
                    { value: 'Thursday', label: 'Thur' },
                    { value: 'Friday', label: 'Fri' },
                    { value: 'Saturday', label: 'Sat' },
                  ]}
                  label="Work Days"
                />
              </div>
            </div>
          </GeckoModal>
        )}
      </GeckoForm>
    </div>
  );
};

export default WorkHoursModal;
